export const MENU_STYLE = {
  maxHeight: '15rem',
  overflowY: 'auto',
  marginTop: '0.75rem',
};

export const MENU_ITEM_STYLE = {
  'backgroundColor': 'transparent',
  'fontSize': '14px',
  'padding': '10px',
  'fontWeight': '400',
  'color': '#43494F',
  '&.Mui-selected': {
    fontWeight: '500',
    fontSize: '14px',
    color: '#141414',
  },
};

export const SELECTED_ELEMENT_STYLE = {
  style: {
    padding: '12px',
    fontSize: '14px',
  },
};
